import {
  Alert,
  Box,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
  alpha,
} from '@mui/material'
import React from 'react'

const CorrectiveActions = ({ incident, handleChange }) => {
  const noActionsRequired = !!incident?.noCorrectiveActionsRequired

  return (
    <Stack gap={2} width="100%">
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          border: '1px solid',
          borderColor: noActionsRequired ? 'success.main' : 'divider',
          bgcolor: (theme) =>
            noActionsRequired
              ? alpha(theme.palette.success.main, 0.06)
              : 'transparent',
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={noActionsRequired}
              onChange={(e) =>
                handleChange('noCorrectiveActionsRequired', e.target.checked)
              }
            />
          }
          label={
            <Box>
              <Typography fontWeight={600}>
                No corrective actions or learning required
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Use this when the review concluded there is nothing to change.
                The incident is then excluded from the CQC Centre "no learning
                recorded" warning.
              </Typography>
            </Box>
          }
          sx={{ alignItems: 'flex-start', m: 0, gap: 1 }}
        />
        {noActionsRequired && (
          <TextField
            label="Reason"
            value={incident?.noCorrectiveActionsReason ?? ''}
            onChange={(e) =>
              handleChange('noCorrectiveActionsReason', e.target.value)
            }
            fullWidth
            autoComplete="off"
            minRows={2}
            multiline
            sx={{ mt: 2 }}
            helperText="Briefly explain why no corrective actions are needed — this is shown on the incident PDF and audit trail."
          />
        )}
      </Box>
      {noActionsRequired && (
        <Alert severity="info" sx={{ borderRadius: 2 }}>
          You can still record Duty of Candour, assessed impact and any other
          notes below — they are optional while this incident is marked as
          requiring no corrective actions.
        </Alert>
      )}
      <TextField
        label="Duty of Candour"
        value={incident?.dutyOfCandour ?? ''}
        onChange={(e) => handleChange('dutyOfCandour', e.target.value)}
        fullWidth
        autoComplete="off"
        minRows={2}
        multiline
      />
      <TextField
        label="Assessed Impact"
        value={incident?.assessedImpact ?? ''}
        onChange={(e) => handleChange('assessedImpact', e.target.value)}
        fullWidth
        autoComplete="off"
        minRows={2}
        multiline
        helperText="In light of the incident findings, has the impact changed?"
      />
      <TextField
        label="Lessons Learned"
        value={incident?.lessonsLearned ?? ''}
        onChange={(e) => handleChange('lessonsLearned', e.target.value)}
        fullWidth
        autoComplete="off"
        minRows={2}
        multiline
      />
      <TextField
        label="Risk Register Additions"
        value={incident?.riskRegisterAdditions ?? ''}
        onChange={(e) => handleChange('riskRegisterAdditions', e.target.value)}
        fullWidth
        autoComplete="off"
        minRows={2}
        multiline
        helperText="Has this incident contributed to changes in the organisation's risk register?"
      />
      <TextField
        label="Recommendations"
        value={incident?.recommendations ?? ''}
        onChange={(e) => handleChange('recommendations', e.target.value)}
        fullWidth
        autoComplete="off"
        minRows={2}
        multiline
        helperText="Are there any further recommendations from the investigation team?"
      />
      <TextField
        label="Actions Required"
        value={incident?.actionsRequired ?? ''}
        onChange={(e) => handleChange('actionsRequired', e.target.value)}
        fullWidth
        autoComplete="off"
        minRows={2}
        multiline
        helperText="What actions are required?"
      />
      {/* TODO: Make this tasks instead */}
    </Stack>
  )
}

export default CorrectiveActions
